import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { Modal } from 'reactstrap';
import classnames from 'classnames';

/* CSS */
import '../../../../Assets/EnsembleStyles/EnsHome.css';
/* Components */
import NavigationBar from '../../../EnsembleComponents/Common/Layouts/NavigationBar/Navigationbar';                                    /* Navigation Bar */
import TitleBar from '../../../EnsembleComponents/Common/Layouts/TitleBar/TitleBar';                                              /* Titile  Bar */
import TenantTabSystem from '../../../EnsembleComponents/TenantComponents/ManageTenants/TenantTabSystem';
// SubRouting
/* Side Bar */
import InactiveWindow from '../../../Logout/InActive';
/* Footer */
import Footer from '../../../EnsembleComponents/Common/Layouts/Footer/EnsembleFooter';
import { getUserPreferences } from '../../../../action/cultureAction';
import { AppRolePermission } from '../../../../action/authenticateUser';
import Idle from 'react-idle';

class ManageTenants extends Component {
    componentWillMount() {
        this.props.getUserPreferences();
        this.props.AppRolePermission(5,18);
        var E_LogoffTime = localStorage.getItem("AutoLogoffTime");
        if (E_LogoffTime !== undefined && E_LogoffTime !== null && E_LogoffTime !== "") {
            this.setState({ LogOffTime : Number(E_LogoffTime) });
        }
    }
    componentDidMount(){
        let StateVal = (this.props.OnPremises !== undefined && this.props.OnPremises !== null) ? this.props.OnPremises : false;
        this.setState({OnPremisesState:StateVal});
    }

    componentWillReceiveProps(nextProps){
        if (this.props !== nextProps) {
            let StateVal = (nextProps.OnPremises !== undefined && nextProps.OnPremises !== null) ? nextProps.OnPremises : false;
            this.setState({OnPremisesState:StateVal});
        }
    }

    showSettings(event) {
        event.preventDefault();
    }

    constructor(props) {
        super(props);
        this.state = {
            sideSize: 300,
            drag: 300,
            inactive_modal: false,
            OnPremisesState : false,
            LogOffTime: 1200000
        }
        this.toggleSide = this.toggleSide.bind(this);
        this.handleDrag = this.handleDrag.bind(this);
        this.Inactivetoggle = this.Inactivetoggle.bind(this);
    }

    toggleSide(action) {
        switch (action) {
            case "open": this.setState({ sideSize: 200, drag: 200 });
                break;
            case "close": this.setState({ sideSize: 1, drag: 1 });
                break;
            default: break;
        }

    }

    handleDrag(width) {
        this.setState({ drag: width + 10 });
    }
    

    Inactivetoggle() {
        this.setState({
            inactive_modal: !this.state.inactive_modal
        });
    }

    Extend_Session = (someArg) => {
        this.Inactivetoggle();
    }


    render(OnPremises) {

        return (
            <div className="Ensemble">
                <Idle timeout={this.state.LogOffTime} onChange={({ idle }) => {
                    if (idle) {
                        this.setState({ inactive_modal: true });
                    }
                }} />
                {
                    !this.state.OnPremisesState ? <div><NavigationBar />
                        <TitleBar parentToChildData={"Tenant Services"} istabView = {true}  />
                        <div className="Ensemble_Content margin_top">
                            <TenantTabSystem />
                        </div>
                        </div> : <div className="Ensemble_Content_FullPage"><TenantTabSystem /></div>
                }

                <Modal isOpen={this.state.inactive_modal} inactive_modal={this.inactive_modal} className={classnames({ classnames: this.props.className }, "ModalContainer InActive_Short_Modal")} >
                    <InactiveWindow Extend_Session={this.Extend_Session} />
                </Modal>

                {
                    !this.state.OnPremisesState ? <Footer /> : ""
                }
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        OnPremises: state.authService.IsOnPremise
    };
};
const mapDispatchToProps = dispatch => {
    return {
        getUserPreferences: () => dispatch(getUserPreferences()),
        AppRolePermission: (actionId,applicationId) => dispatch(AppRolePermission(actionId,applicationId))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageTenants);
